const BookUs = () => {
  return (
    <div className="bg-zinc-100 flex flex-col py-20 p-20 justify-start w-screen">
      BOOK US
    </div>
  );
};

export default BookUs;
